// extracted by mini-css-extract-plugin
module.exports = {"shape":"loading_shape__VTW_M","transform-animation":"loading_transform-animation__MW580","loadingArea":"loading_loadingArea___Q5rN"};